module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/next-64.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/next.md
// module id = 481
// module chunks = 420